import { useEffect, useState } from 'react';
import handleChange, { handleInputChange } from '../../../../../utils/handleChange';
import Dropdown, { Dropdown1 } from '../../../../../components/dropdown/Dropdown';
// import { getFormattedDateReverse } from '../../../../../utils/date';
import Tooltip from '../../../../../components/tooltip/Tooltip';
import { ReactComponent as InfoI } from '../../../../../assets/icons/trvto_info.svg';

const VehicleFixedBookingTab = ({
    booking,
    setBooking,
    numPeople,
    confirmedBookingData,
    numOfRooms,
    startDates,
    handleSelectedDate,
    isDateSelected,
    selectedDate,
    packData,
    transport,
    handleBaseCity,
    startCity,
    setIndex,
    optionsForMeetUpLocation,
    vehicleModes,
    comfortableOptions,
    packDates
}) => {
    const [isRoomChecked, setIsRoomChecked] = useState(false);
    const [totalAvailiableRooms, setTotalAvailiableRooms] = useState();

    const handleRoomCheckbox = (event) => {
        const checked = event.target.checked;
        setIsRoomChecked(checked);
        if (!checked) {
            setBooking((prev) => ({
                ...prev,
                room: 0
            }));
        }
    };

    useEffect(() => {
        setTotalAvailiableRooms(packDates?.reduce((acc, item) => acc + item.totalRooms, 0));
        setIsRoomChecked(booking?.room > 0 ? true : false);
        //eslint-disable-next-line
    }, [packDates]);
    return (
        <div>
            <>
                <div className='dropdownDiv'>
                    <label className='tripBookDatalabelFirst'>No. of People</label>
                    <select
                        value={booking.people}
                        name='people'
                        onChange={(e) => handleChange(e, setBooking)}
                        required={true}
                        className='dropdownSelect'
                        disabled={confirmedBookingData?.userDetails.length}
                    >
                        {numPeople.map(function (val, typeIndex) {
                            return (
                                <option key={typeIndex} value={val}>
                                    {val}
                                </option>
                            );
                        })}
                    </select>
                </div>
                <div className='dropdownDiv bookingDate'>
                    {/* <label className='tripBookDatalabel2'>Select Date</label>
                        <SingleDatePicker
                            date={booking.date}
                            onDateChange={(date) => {
                                setBooking((prevState) => {
                                    return { ...prevState, date: date };
                                });
                                handleSelectedDate(date);
                            }}
                            focused={focused}
                            onFocusChange={({ focused }) => setFocused(focused)}
                            numberOfMonths={1}
                            displayFormat='DD-MM-YYYY'
                            isDayBlocked={isDayBlocked}
                            isOutsideRange={(day) => day.isBefore(moment(), 'day')}
                        /> */}
                    <Dropdown1
                        label='Select Date'
                        name='date'
                        options={startDates}
                        value={booking.date}
                        req={true}
                        setFormData={setBooking}
                        handleSelectedDate={handleSelectedDate}
                        disabled={confirmedBookingData?.startDate && confirmedBookingData?.isTripMoreThanOneDays}
                    />
                    {/* {isDateSelected ? (
                        <p className='slotsLeft'>
                            Slots left{' '}
                            {selectedDate?.totalSlots - selectedDate?.bookedSlots > 15
                                ? 15
                                : selectedDate?.totalSlots - selectedDate?.bookedSlots}{' '}
                            & Booking ends on {getFormattedDateReverse(selectedDate?.bookingEnd)}
                        </p>
                    ) : (
                        <></>
                    )} */}
                </div>
                {packData.withoutTransportPrice !== 0 && (
                    <Dropdown
                        label='Transport'
                        name='transport'
                        options={transport}
                        value={booking.transport}
                        req={true}
                        setFormData={setBooking}
                    />
                )}
                {booking.transport === 'With transport' && (
                    <>
                        <div className='dropdownDiv'>
                            <div className='dropdownLabelText'>
                                <label className='dropdownlabel'>Start City</label>
                                <Tooltip content='Select the city from where you trip starts' position='top'>
                                    <span className='eyeIcon'>
                                        <InfoI color='blue' width={15} height={15} />
                                    </span>
                                </Tooltip>
                            </div>
                            <select
                                value={booking.startCity}
                                name='startCity'
                                onChange={(e) => handleBaseCity(e, setBooking, startCity.current, setIndex)}
                                required={true}
                                className='dropdownSelect'
                                disabled={confirmedBookingData?.startCity}
                            >
                                <option value='-1'>Select</option>
                                {startCity.current.map(function (val, typeIndex) {
                                    return (
                                        <option key={typeIndex} value={val}>
                                            {val}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                        <Dropdown
                            label='Meetup Location'
                            name='pickupLocation'
                            options={optionsForMeetUpLocation}
                            value={booking?.pickupLocation}
                            req={true}
                            setFormData={setBooking}
                            disabled={
                                (!confirmedBookingData?.isTripMoreThanOneDays &&
                                    confirmedBookingData?.pickupLocation) ||
                                !booking?.startCity
                            }
                            infoIcon={true}
                            infoContent={'Select the location from where you want to join the trip'}
                        />
                        <Dropdown
                            label='Select Vehicle'
                            name='vehicleType'
                            options={vehicleModes}
                            value={booking?.vehicleType}
                            req={true}
                            setFormData={setBooking}
                            disabled={confirmedBookingData?.vehicle?.mode}
                            infoIcon={true}
                            infoContent={
                                <div style={{ whiteSpace: 'pre-line' }}>
                                    Select a vehicle for your trip based on your requirements.
                                    {'\n'}
                                    <strong>Self Bike:</strong> Bring your own bike or ride with someone who has one.
                                    {'\n'}
                                    <strong>Self Car:</strong> Bring your own car or ride with someone who has one.
                                    {'\n'}
                                    <strong>Pillion on Bike:</strong> Join as a pillion with another rider (share fuel
                                    cost).{'\n'}
                                    <strong>Co-passenger in Car:</strong> Join as a co-passenger with another driver
                                    (share fuel cost).{'\n'}
                                    <strong>Bike Rent:</strong> Organizer provides a rental bike (fuel extra).{'\n'}
                                    <strong>Car Rent:</strong> Organizer provides a rental car (fuel extra)
                                </div>
                            }
                        />
                        {!confirmedBookingData?.vehicle?.mode && (
                            <div className='vehicle-input-container'>
                                {['Self Bike', 'Self Car'].includes(booking?.vehicleType) && (
                                    <>
                                        <div className='dropdownLabelText'>
                                            <label htmlFor='vehicleModel' className='vehicle-label'>
                                                Model
                                            </label>
                                            <Tooltip
                                                content='Enter the make and model of your vehicle (e.x., Maruti Swift, Royal Enfield Classic)'
                                                position='top'
                                            >
                                                <span className='eyeIcon'>
                                                    <InfoI color='blue' width={15} height={15} />
                                                </span>
                                            </Tooltip>
                                        </div>
                                        <input
                                            id='vehicleModel'
                                            name='vehicleModel'
                                            type='text'
                                            className='vehicle-input'
                                            placeholder={
                                                booking?.vehicleType === 'Self Bike'
                                                    ? 'e.x. Royal Enfield Classic'
                                                    : 'e.x. Maruti Swift'
                                            }
                                            value={booking?.vehicleModel}
                                            onChange={(e) => handleInputChange(e, setBooking)}
                                        />
                                    </>
                                )}

                                {/* Always show Comfortable dropdown */}
                                {booking?.vehicleType !== '-1' &&
                                    booking?.vehicleType !== '' &&
                                    !['Pillion on bike', 'Co-passenger in car'].includes(booking?.vehicleType) && (
                                        <>
                                            <Dropdown
                                                label='Comfortable'
                                                name='comfortable'
                                                options={comfortableOptions}
                                                value={booking?.comfortable}
                                                req={true}
                                                setFormData={setBooking}
                                                infoIcon={InfoI}
                                                infoContent='Are you comfortable adding a person to your vehicle, If yes choose Yes.'
                                            />
                                            {booking?.comfortable === 'Yes' && (
                                                <>
                                                    <div className='dropdownLabelText'>
                                                        <label
                                                            style={{ marginTop: 10 }}
                                                            htmlFor='emptySeats'
                                                            className='vehicle-label'
                                                        >
                                                            Empty Seats
                                                        </label>
                                                        <Tooltip
                                                            content='Are you comfortable adding a person to your vehicle, If yes enter number of seats available or leave it blank'
                                                            position='top'
                                                        >
                                                            <span className='eyeIcon'>
                                                                <InfoI color='blue' width={15} height={15} />
                                                            </span>
                                                        </Tooltip>
                                                    </div>
                                                    <input
                                                        id='emptySeats'
                                                        name='emptySeats'
                                                        type='number'
                                                        className='vehicle-input'
                                                        placeholder='e.x. 2'
                                                        value={booking?.emptySeats}
                                                        min='0'
                                                        max='6'
                                                        onChange={(e) => {
                                                            const { name, value } = e.target;
                                                            // Remove leading zeros but allow empty input
                                                            const cleanValue =
                                                                value === '' ? '' : String(Number(value));
                                                            setBooking((prev) => ({ ...prev, [name]: cleanValue }));
                                                        }}
                                                    />{' '}
                                                </>
                                            )}
                                        </>
                                    )}
                            </div>
                        )}

                        {totalAvailiableRooms > 0 &&
                        (packData?.room || packData?.price[0]?.price?.room) &&
                        (packData?.room || packData?.price[0]?.price?.room > 0) ? (
                            <>
                                <div id='checkbox-div'>
                                    <input
                                        type='checkbox'
                                        id='roomCheck'
                                        checked={isRoomChecked}
                                        onChange={handleRoomCheckbox}
                                        disabled={confirmedBookingData?.startCity}
                                    />
                                    <label
                                        htmlFor='roomCheck'
                                        id='tripReserveLabel'
                                        style={{
                                            fontFamily: 'inherit',
                                            fontSize: '26px',
                                            paddingLeft: '26px',
                                            lineHeight: '16px',
                                            paddingTop: '6px'
                                        }}
                                    >
                                        Are you looking for personal room at extra price
                                    </label>
                                </div>
                                {isRoomChecked && (
                                    <div className='dropdownDiv dropdown-room-div'>
                                        <div>
                                            <label className='tripBookDatalabelFirst'>No. of Rooms</label>
                                            <span style={{ marginLeft: 5 }}>
                                                <Tooltip
                                                    content='Select the number of rooms you want to book (optional)'
                                                    position='top'
                                                >
                                                    <span className='eyeIcon'>
                                                        <InfoI color='blue' width={15} height={15} />
                                                    </span>
                                                </Tooltip>
                                            </span>
                                        </div>
                                        <select
                                            value={booking.room || ''}
                                            name='room'
                                            onChange={(e) =>
                                                setBooking((prev) => ({
                                                    ...prev,
                                                    room: Number(e.target.value)
                                                }))
                                            }
                                            required={true}
                                            className='dropdownSelect'
                                        >
                                            <option value={''}>Select</option>
                                            {numOfRooms.map(function (val, typeIndex) {
                                                return (
                                                    <option key={typeIndex} value={val}>
                                                        {val}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                    </div>
                                )}
                            </>
                        ) : null}
                    </>
                )}
            </>
        </div>
    );
};

export default VehicleFixedBookingTab;
